import Utils from "../../../utility";

const initialState = {
  bannerList: [],
  order: "DESC",
  sortField: "userName",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  announcementList: [],
};
export const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.BANNER}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
